export interface AirportMessageRecord {
    id: number;
    airport: string;
    messageType: string;
    messageContent: string;
    validFrom: Date;
    validUntil: Date;
}